import { useState, useEffect } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { getUserPermissions, hasSignedLatestTermsAndConditions } from "../utils/Permissions";
import { TermsAcceptancePage } from "./Terms/TermsAcceptancePage";
import { LoadingScreen } from "./LoadingScreen";

export const PrivateRoute = ({ children }) => {
    const { isAuthenticated, loginWithRedirect, isLoading, getAccessTokenSilently, user } = useAuth0();

    const [isAccountValid, setIsAccountValid] = useState(null); // null = loading, true/false = resolved
    const [userPermissions, setUserPermissions] = useState(null);
    const [needsTerms, setNeedsTerms] = useState(false);

    //Get necessary data on screen load
    useEffect(() => {
        if (!isLoading) {
            if (isAuthenticated && user && user.sub) {
                const userId = user.sub.split('|')[1];
                checkValidAccount(userId);
            }
        }
    }, [isLoading]);

    const checkValidAccount = async (userId) => {
        try {
            const token = await getAccessTokenSilently();
            const permissions = await getUserPermissions(token, userId);

            if (!permissions || !permissions.permissions) {
                setIsAccountValid(false);
            } else {
                setUserPermissions(permissions);
                if (!hasSignedLatestTermsAndConditions(permissions)) {
                    setNeedsTerms(true);
                }
                setIsAccountValid(true);
            }
        } catch (error) {
            console.error('checkValidAccount failed:', error);
            setIsAccountValid(false);
        }
    }

    const handleTermsAccepted = () => {
        setNeedsTerms(false);
    };

    const AccountSetup = () => {
        return (
            <div>
                {isAccountValid === true && isAuthenticated && needsTerms && (
                    <TermsAcceptancePage permissions={userPermissions} onAccepted={handleTermsAccepted} />
                )}
                {isAccountValid === true && isAuthenticated && !needsTerms && (children)}
                {(isLoading || (isAuthenticated && isAccountValid === null)) && (<LoadingScreen />)}
                {!isAuthenticated && !isLoading && (
                    <div className="login-message text-center">
                        <Row>
                            <Col></Col>
                            <Col>
                                <h1 className="mt-9 mb-3">Welcome</h1>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col></Col>
                            <Col xs={7}>
                                <h3 className="mt-2 mb-3">To view trades and make adjustments to your account login below.</h3>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col></Col>
                            <Col>
                                <Button
                                    className="mt-4 mb-3"
                                    variant="outline-success"
                                    onClick={() => loginWithRedirect({
                                        appState: {
                                            returnTo: window.location.pathname
                                        }
                                    })}
                                >
                                    Login
                                </Button>
                            </Col>
                            <Col></Col>
                        </Row>
                    </div>
                )}
                {
                    !isLoading && isAuthenticated && isAccountValid === false && (
                        <Container>
                            <Row>
                                <Col></Col>
                                <Col xs={10} className="bg-light mt-3 ml-3 mb-4 mr-3 pt-3 pb-3 justify-content-left">
                                    <h3 className="border-bottom mb-2 pb-2 text-danger">
                                        This website is for authorized use only.
                                    </h3>
                                    <h4 className="mb-2 pb-2 text-danger">
                                        If you are a new user who has been approved to use this website, your account is in the process of being set up. Check back later.
                                    </h4>
                                    <h4 className="mb-2 pb-2 text-danger">
                                        Contact your licensor if you believe you have reached this message in error.
                                    </h4>
                                </Col>
                                <Col></Col>
                            </Row>
                        </Container>
                    )
                }
            </div>
        )
    }

    return <AccountSetup />
};